import { Link } from 'react-router-dom';
import { Button } from './ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="font-display text-3xl font-semibold text-ink">Página não encontrada</h1>
      <p className="text-muted">O endereço que você tentou acessar não existe.</p>
      <Link to="/">
        <Button>Voltar ao início</Button>
      </Link>
    </div>
  );
}
